// const defaultSearchSuggestions = () => {
const defaultSearchSuggestions = ({
  isDeveloper,
  isFieldEngineer,
  isFieldAdmin,
  isOperations,
  isDeviceManagement,
}) => {
  const features = [];
  [
    {
      id: "buildingsPage",
      target: "buildingsPage",
      isBookmarked: false,
      title: "Building List",
      icon: "List",
      link: "/buildingslist",
    },
    {
      id: "alertsPage",
      target: "alertsPage",
      isBookmarked: false,
      title: "Manage Alerts",
      icon: "AlertCircle",
      link: "/alerts",
      options: {
        a: "a",
        b: [1, 2, 3],
      },
    },
    {
      id: "dataPage",
      target: "Data",
      isBookmarked: false,
      title: "Data",
      icon: "Database",
      link: "/data",
    },
  ].map((e) => features.push(e));
  [
    {
      id: "userPage",
      target: "Users",
      isBookmarked: false,
      title: "Users",
      icon: "Users",
      link: "/users",
    },
  ].map((e) => {
    if (isDeveloper || isFieldAdmin || isFieldEngineer || isOperations) {
      features.push(e);
    }
  });
  [
    {
      id: "devicemanagementPage",
      target: "Devices",
      isBookmarked: false,
      title: "Devices",
      icon: "Cpu",
      link: "/dm",
    },
    {
      id: "otapage",
      target: "OTA",
      isBookmarked: false,
      title: "OTA",
      icon: "Wifi",
      link: "/dm/ota",
    },
  ].map((e) => {
    if (isDeviceManagement) {
      features.push(e);
    }
  });
  [
    {
      id: "settingsPage",
      target: "Settings",
      isBookmarked: false,
      title: "Settings",
      icon: "Settings",
      link: "/settings",
    },
    {
      id: "inboxPage",
      target: "InBox",
      isBookmarked: false,
      title: "In Box",
      icon: "Mail",
      link: "/inbox",
    },
  ].map((e) => features.push(e));
  return [
    {
      groupTitle: "Features",
      searchLimit: 4,
      data: features,
    },
    // {
    //   groupTitle: "Active Pages",
    //   searchLimit: 10,
    //   data: [],
    // },
    {
      groupTitle: "Bookmarks",
      searchLimit: 10,
      data: [],
    },
  ];
};

export default defaultSearchSuggestions;
